import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

import { ReactComponent as BrandBanner } from '../../../assets/images/login/brand.svg';
import { useBranding } from '../../../contexts/BrandingContext';

import ConsumerDelete from './ConsumerDelete';
import EmailVerification from './EmailVerification';
import ForgetPassword from './ForgetPassword';
import InitialPasswordReset from './InitialPasswordReset';
import LoginComponent from './LoginComponent';
import NewPasswordChange from './NewPasswordChange';
import OTPVerification from './OTPVerification';
import PhoneNumberVerification from './PhoneNumberVerification';
import RegisterV3 from './Register';

/**
 * Login component
 * @returns {any} The rendered Login component.
 * @description Login component is a component for login functionality.
 */
function LoginV3(): React.JSX.Element {
  const { t, i18n } = useTranslation('loginV2');
  const { page } = useParams<Record<string, string>>();
  const { brandData } = useBranding();
  const runtimeLogo = brandData?.logo;

  const hindMessage = [
    {
      key: 'credentials',
      title: t('getStartedNow'),
      message: t('enterYourCredentialAccessYourAccount'),
    },
    {
      key: 'otp-verification',
      title: t('otpVerification'),
      message: t('pleaseEnterTheOtpReceivedThatWhichYouRegisteredEmailId'),
    },
    {
      key: 'forgot-password',
      title: t('forgotPassword'),
      message: t('pleaseEnterTheRegisteredPhoneNumberEmailId'),
    },
    {
      key: 'consumer-delete',
      title: t('driverDelete'),
      message: t('pleaseEnterTheRegisteredPhoneNumberEmailId'),
    },
    // portal login pages url
    {
      key: 'email-verification',
      title: t('otpVerification'),
      message: t('pleaseEnterTheOtpReceivedThatWhichYouRegisteredEmailId'),
    },
    {
      key: 'phone-number-verification',
      title: t('otpVerification'),
      message: t('enterTheVerificationCodeSentToYourPhoneNumber'),
    },
    {
      key: 'forgot-password-otp-verification',
      title: t('otpVerification'),
      message: t('enterTheVerificationCodeSentToYourPhoneNumberEmail'),
    },
    {
      key: 'reset-password',
      title: t('createPassword'),
      message: t('dontWorryYouCanCreateNewPasswordHere'),
    },
    {
      key: 'reset-initial-password',
      title: t('createPassword'),
      message: t('dontWorryYouCanCreateNewPasswordHere'),
    },
    {
      key: 'register',
      title: t('getStartedNow'),
      message: t('enterYourCredentialAccessYourAccount'),
    },
  ];

  return (
    <div className="login-wrapper" dir={i18n.dir()}>
      <div className="login-content">
        <div className="login-content-top">
          <div className="brand-container">
            <div className="backdrop">
              <div className="red" />
              <div className="green" />
            </div>
            {runtimeLogo ? (
              <img src={runtimeLogo} alt="brand" className="brand-banner" />
            ) : (
              <BrandBanner className="brand-banner" />
            )}
          </div>
          <div className="text-container">
            <p className="title">{hindMessage.find((item) => item.key === page)?.title}</p>
            <p className="description">{hindMessage.find((item) => item.key === page)?.message}</p>
          </div>
        </div>
        <div className="login-content-bottom">
          <div className="login-page-content">
            {(() => {
              let pageContent;
              if (page === 'forgot-password') {
                pageContent = <ForgetPassword />;
              } else if (page === 'register') {
                pageContent = <RegisterV3 />;
              } else if (page === 'otp-verification') {
                pageContent = <OTPVerification />;
              } else if (page === 'reset-initial-password') {
                pageContent = <InitialPasswordReset />;
              } else if (page === 'email-verification') {
                pageContent = <EmailVerification />;
              } else if (page === 'phone-number-verification') {
                pageContent = <PhoneNumberVerification />;
              } else if (page === 'new-password') {
                pageContent = <NewPasswordChange />;
              } else if (page === 'consumer-delete') {
                pageContent = <ConsumerDelete />;
              } else {
                pageContent = <LoginComponent />;
              }
              return pageContent;
            })()}
          </div>
          {page === 'credentials' && (
            <div className="login-footer">
              {brandData?.clientName?.toLowerCase() === 'svvalley' && (
                <>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                  <span>|</span>
                  <Link to="/login/consumer-delete">Delete Account</Link>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default LoginV3;
